<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- LIST -->
  <ng-container *ngIf="viewMode() === 'list'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">local_parking</span>
          </span>
          ลานจอดที่แสดงหน้า Home
        </h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          จัดการลานจอดที่แสดงบนหน้า Home ของ LIFF — การ์ดลาน · หน้ารายละเอียดลาน · แผนที่
        </p>
      </div>
      <div class="flex flex-col sm:flex-row sm:items-center gap-3 self-start md:self-end">
        <div class="inline-flex items-center gap-2 h-[46px] pl-3 pr-1.5 rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700 shadow-sm">
          <div class="flex flex-col justify-center min-w-[7.5rem] pr-1 border-r border-slate-100 dark:border-slate-700">
            <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
            <span class="text-[13px] font-bold leading-none tabular-nums"
              [class.text-slate-600]="lastFetchedTime()"
              [class.dark:text-slate-300]="lastFetchedTime()"
              [class.text-slate-300]="!lastFetchedTime()"
              [class.dark:text-slate-600]="!lastFetchedTime()">
              {{ lastFetchedTime() ? (lastFetchedTime() | date:'HH:mm:ss') : '--:--:--' }}
            </span>
          </div>
          <button type="button" (click)="reload()" [disabled]="isLoading() || isSaving()" title="โหลดข้อมูลใหม่"
            class="w-9 h-9 rounded-xl text-slate-500 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all flex items-center justify-center disabled:opacity-40 cursor-pointer">
            <span class="material-icons text-[20px]" [class.animate-spin]="isLoading()">refresh</span>
          </button>
        </div>
        <button *ngIf="canCreate" type="button" (click)="openCreate()"
          class="px-5 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer border-none">
          <span class="material-icons text-[18px]">add</span>
          เพิ่มลานจอด
        </button>
      </div>
    </div>

    <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden relative">
      <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">local_parking</span>
            รายการลานจอด
          </h3>
          <p class="text-xs text-slate-400 mt-1">ข้อมูลของแต่ละลานใช้ร่วมกันใน LIFF: การ์ด Home · หน้ารายละเอียดลาน · แผนที่</p>
        </div>
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
          <select [(ngModel)]="filterPublished" (ngModelChange)="onSearch()"
            class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">เผยแพร่ทั้งหมด</option>
            <option value="true">เผยแพร่แล้ว</option>
            <option value="false">ยังไม่เผยแพร่</option>
          </select>
          <select [(ngModel)]="filterActive" (ngModelChange)="onSearch()"
            class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">สถานะทั้งหมด</option>
            <option value="true">ใช้งาน</option>
            <option value="false">ปิดใช้</option>
          </select>
          <select [(ngModel)]="filterSiteOnline" (ngModelChange)="onSearch()"
            class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">ออนไลน์ทั้งหมด</option>
            <option value="true">ออนไลน์</option>
            <option value="false">ออฟไลน์</option>
          </select>
          <div class="relative w-full sm:w-72">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" placeholder="ค้นหาชื่อที่แสดง / ลานจอด..."
              class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
          </div>
        </div>
      </div>

      <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
        <table class="w-full text-left border-collapse"
          [class.opacity-50]="isLoading()" [class.pointer-events-none]="isLoading()">
          <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4 w-20">ปก</th>
              <th class="p-4">ชื่อที่แสดง</th>
              <th class="p-4">ลานจอด (Site)</th>
              <th class="p-4 text-center">ออนไลน์</th>
              <th class="p-4 text-center">รูป</th>
              <th class="p-4 text-center">บล็อก</th>
              <th class="p-4 text-center">สถานะ</th>
              <th class="p-4 text-center w-[120px]">จัดการ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
            <tr *ngFor="let item of items(); trackBy: trackById"
              class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
              <td class="p-4">
                <button *ngIf="item.coverImage; else noCover" type="button" (click)="openImageModal(item.coverImage!)"
                  class="w-14 h-10 rounded-xl overflow-hidden border border-slate-100 dark:border-slate-700 p-0 bg-slate-100 dark:bg-slate-900">
                  <img [src]="item.coverImage" alt="" class="w-full h-full object-cover" />
                </button>
                <ng-template #noCover>
                  <div class="w-14 h-10 rounded-xl bg-slate-100 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 flex items-center justify-center">
                    <span class="material-icons text-slate-300 text-base">image</span>
                  </div>
                </ng-template>
              </td>
              <td class="p-4">
                <p class="font-bold text-slate-700 dark:text-slate-200">{{ item.titleTh || '—' }}</p>
                <p *ngIf="item.titleEn" class="text-xs text-slate-400 mt-0.5 line-clamp-1">{{ item.titleEn }}</p>
              </td>
              <td class="p-4">
                <p class="font-bold text-slate-700 dark:text-slate-200">{{ item.siteName || '—' }}</p>
              </td>
              <td class="p-4 text-center">
                <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                  [ngClass]="item.siteIsOnline
                    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                    : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                  {{ item.siteIsOnline ? 'ออนไลน์' : 'ออฟไลน์' }}
                </span>
              </td>
              <td class="p-4 text-center">
                <span class="inline-flex min-w-[2rem] justify-center px-2.5 py-1 rounded-full text-xs font-bold bg-sky-50 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400">
                  {{ item.imageCount }}
                </span>
              </td>
              <td class="p-4 text-center">
                <span class="inline-flex min-w-[2rem] justify-center px-2.5 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
                  {{ item.blockCount }}
                </span>
              </td>
              <td class="p-4 text-center">
                <div class="inline-flex flex-col gap-1 items-center">
                  <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                    [ngClass]="item.isPublished
                      ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                      : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                    {{ item.isPublished ? 'เผยแพร่' : 'ร่าง' }}
                  </span>
                  <span *ngIf="!item.isActive"
                    class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-400">
                    ปิดใช้
                  </span>
                </div>
              </td>
              <td class="p-4 text-center whitespace-nowrap">
                <button *ngIf="canUpdate" type="button" (click)="openEdit(item)" title="แก้ไข"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer mr-1">
                  <span class="material-icons text-base">edit</span>
                </button>
                <button *ngIf="canDelete" type="button" (click)="askDelete(item)" title="ลบ"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-rose-400 hover:text-rose-500 transition-all cursor-pointer">
                  <span class="material-icons text-base">delete</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="!isLoading() && items().length === 0">
              <td colspan="8" class="py-20 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40 block">local_parking</span>
                <p class="font-bold">ยังไม่มีลานจอดที่แสดงหน้า Home</p>
                <p class="text-xs mt-1">กด “เพิ่มลานจอด” เพื่อเริ่มต้น</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
          <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalCount() | number }} รายการ</span>
          <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="onPageChange(page() - 1)" [disabled]="page() <= 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <button type="button" *ngFor="let p of pagesArray" (click)="onPageChange(p)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer"
            [ngClass]="p === page() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
            {{ p }}
          </button>
          <button type="button" (click)="onPageChange(page() + 1)"
            [disabled]="page() >= totalPages || totalPages === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- EDIT / CREATE -->
  <ng-container *ngIf="viewMode() === 'edit'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <button type="button" (click)="backToList()"
          class="mb-2 inline-flex items-center gap-1 text-xs font-bold text-slate-400 hover:text-amber-600 transition-colors">
          <span class="material-icons text-[16px]">arrow_back</span>
          กลับรายการ
        </button>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">{{ draft().id ? 'edit_note' : 'add_circle' }}</span>
          </span>
          {{ draft().id ? 'แก้ไขลานจอด' : 'เพิ่มลานจอด' }}
        </h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          ตั้งชื่อที่แสดง ที่อยู่ รูปปก และเนื้อหาของลานจอดที่แสดงหน้า Home
        </p>
      </div>
      <div class="flex flex-wrap items-center gap-3 self-start md:self-end">
        <button *ngIf="canShowActivityHistory" type="button" (click)="openHistory()"
          class="px-4 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center justify-center gap-2">
          <span class="material-icons text-[18px]">history</span>
          ดูประวัติ
        </button>
        <button type="button" (click)="backToList()" [disabled]="isSaving()"
          class="px-5 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 transition-all disabled:opacity-40">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="px-6 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 disabled:opacity-40 border-none">
          <span class="material-icons text-[18px]">{{ isSaving() ? 'hourglass_top' : 'save' }}</span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>

    <div class="mb-6 flex flex-wrap gap-2 p-1.5 bg-white/95 dark:bg-slate-800/95 rounded-2xl border border-slate-100/50 dark:border-slate-700 shadow-sm w-full md:w-fit">
      <button *ngFor="let tab of editTabs" type="button" (click)="setEditTab(tab.value)"
        class="flex-1 md:flex-none px-4 h-10 rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2 border-none cursor-pointer"
        [ngClass]="editTab() === tab.value
          ? 'bg-amber-400 text-slate-900 shadow-md shadow-amber-200/50 dark:shadow-none'
          : 'bg-transparent text-slate-500 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-700'">
        <span class="material-icons text-[18px]">{{ tab.icon }}</span>
        <span class="whitespace-nowrap">{{ tab.label }}</span>
        <span *ngIf="editTabBadge(tab.value) !== null"
          class="min-w-[1.5rem] px-1.5 h-5 rounded-full text-[11px] font-black inline-flex items-center justify-center"
          [ngClass]="editTab() === tab.value ? 'bg-slate-900/10 text-slate-900' : 'bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-300'">
          {{ editTabBadge(tab.value) }}
        </span>
      </button>
    </div>

    <div class="relative space-y-6 animate-fade-in">
      <section *ngIf="editTab() === 'general'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
        <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-sm text-sky-900 dark:text-sky-100">
          เลือกลานจอดและกรอกชื่อที่แสดง — เผยแพร่ต้องมีรูปปก
        </div>

        <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">title</span>
          ข้อมูลลานจอด
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="md:col-span-2 relative">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              ลานจอด (Site) <span class="text-rose-500">*</span>
            </label>
            <div *ngIf="draft().id > 0"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-100 dark:bg-slate-800/80 text-sm font-bold flex items-center gap-2 text-slate-600 dark:text-slate-300">
              <span class="material-icons text-slate-400 text-[18px]">lock</span>
              {{ draft().siteName || ('Site #' + draft().siteId) }}
              <span class="inline-flex ml-auto px-2 py-0.5 rounded-full text-[10px] font-bold"
                [ngClass]="draft().siteIsOnline
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-slate-200 text-slate-500 dark:bg-slate-700 dark:text-slate-400'">
                {{ draft().siteIsOnline ? 'ออนไลน์' : 'ออฟไลน์' }}
              </span>
            </div>
            <ng-container *ngIf="draft().id === 0">
              <div class="relative h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center focus-within:ring-2 focus-within:ring-amber-200">
                <span class="material-icons text-slate-400 text-[20px] absolute left-3">search</span>
                <input type="text"
                  [ngModel]="siteSearchText"
                  (ngModelChange)="onSiteSearchInput($event)"
                  (focus)="openSiteDropdown()"
                  (blur)="closeSiteDropdown()"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="ค้นหาและเลือกลานจอด..."
                  class="w-full h-full pl-10 pr-10 bg-transparent border-none text-sm font-medium outline-none" />
                <span class="material-icons text-slate-400 text-[18px] absolute right-3 pointer-events-none"
                  [class.rotate-180]="showSiteDropdown">expand_more</span>
              </div>
              <div *ngIf="showSiteDropdown" (mousedown)="$event.preventDefault()"
                class="absolute z-30 left-0 right-0 mt-1 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 max-h-56 overflow-y-auto custom-scrollbar">
                <button *ngFor="let opt of filteredSiteOptions" type="button"
                  (mousedown)="selectSite(opt); $event.preventDefault()"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-700 transition-colors flex items-center justify-between gap-2 border-0 bg-transparent cursor-pointer">
                  <span class="truncate">{{ opt.name }}</span>
                  <span class="inline-flex shrink-0 px-2 py-0.5 rounded-full text-[10px] font-bold"
                    [ngClass]="opt.isOnline
                      ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                      : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-400'">
                    {{ opt.isOnline ? 'ออนไลน์' : 'ออฟไลน์' }}
                  </span>
                </button>
                <div *ngIf="!filteredSiteOptions.length"
                  class="px-4 py-6 text-center text-xs text-slate-400 font-medium">
                  ไม่พบลานจอดที่ยังไม่ได้เพิ่มในหน้า Home
                </div>
              </div>
            </ng-container>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ลำดับ</label>
            <input type="number"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-bold outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().sortOrder" (ngModelChange)="patchDraft({ sortOrder: +$event || 0 })" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อที่แสดง (TH) <span class="text-rose-500">*</span></label>
            <input
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().titleTh" (ngModelChange)="patchDraft({ titleTh: $event })" [ngModelOptions]="{ standalone: true }"
              placeholder="เช่น อาคารจอดรถ A" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อที่แสดง (EN)</label>
            <input
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().titleEn" (ngModelChange)="patchDraft({ titleEn: $event })" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สรุปสั้น (TH)</label>
            <textarea rows="2"
              class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
              [ngModel]="draft().summaryTh" (ngModelChange)="patchDraft({ summaryTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สรุปสั้น (EN)</label>
            <textarea rows="2"
              class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
              [ngModel]="draft().summaryEn" (ngModelChange)="patchDraft({ summaryEn: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ที่อยู่ (TH)</label>
            <textarea rows="2"
              class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
              [ngModel]="draft().addressTh" (ngModelChange)="patchDraft({ addressTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ที่อยู่ (EN)</label>
            <textarea rows="2"
              class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
              [ngModel]="draft().addressEn" (ngModelChange)="patchDraft({ addressEn: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
          </div>
          <div class="flex flex-wrap items-center gap-6 md:col-span-2">
            <label class="inline-flex items-center gap-2 cursor-pointer select-none">
              <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                [ngModel]="draft().isPublished"
                (ngModelChange)="patchDraft({ isPublished: $event })" [ngModelOptions]="{ standalone: true }" />
              <span class="font-bold text-slate-700 dark:text-slate-200">เผยแพร่บน LIFF</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer select-none">
              <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                [ngModel]="draft().isActive"
                (ngModelChange)="patchDraft({ isActive: $event })" [ngModelOptions]="{ standalone: true }" />
              <span class="font-bold text-slate-700 dark:text-slate-200">ใช้งาน</span>
            </label>
          </div>
        </div>

        <div class="pt-2 border-t border-slate-100 dark:border-slate-800">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">
            รูปปก <span class="text-rose-500" *ngIf="draft().isPublished">*</span>
            <span class="normal-case font-medium text-slate-400" *ngIf="!draft().isPublished">(optional จนกว่าจะเผยแพร่)</span>
          </label>
          <div class="flex flex-wrap items-start gap-4">
            <button *ngIf="coverSrc(draft())" type="button" (click)="openImageModal(coverSrc(draft()))"
              class="w-44 h-28 rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 p-0 shadow-sm">
              <img [src]="coverSrc(draft())" alt="" class="w-full h-full object-cover" />
            </button>
            <div *ngIf="!coverSrc(draft())"
              class="w-44 h-28 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 flex flex-col items-center justify-center text-slate-400">
              <span class="material-icons mb-1">image</span>
              <span class="text-[11px] font-bold">ยังไม่มีรูปปก</span>
            </div>
            <div class="space-y-2">
              <label class="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 border border-amber-100 dark:border-amber-800/50 font-bold text-xs cursor-pointer hover:bg-amber-100/80 transition-colors">
                <span class="material-icons text-[16px]">image</span>
                เลือกรูปปก
                <input type="file" accept="image/*" class="hidden" (change)="onCoverSelected($event)" />
              </label>
              <button *ngIf="coverSrc(draft())" type="button" (click)="clearCover()"
                class="block text-xs font-bold text-rose-500 hover:underline">ลบรูปปก</button>
              <p class="text-[11px] text-slate-400">รองรับไฟล์รูป ไม่เกิน 10MB</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Gallery -->
      <section *ngIf="editTab() === 'gallery'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
        <div class="flex flex-col lg:flex-row lg:items-start justify-between gap-4">
          <div>
            <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
              <span class="material-icons text-amber-500">photo_library</span>
              รูปภาพลานจอด
              <span class="text-xs font-bold text-slate-400">({{ draft().images.length }}/{{ maxGalleryImages }})</span>
            </h2>
            <p class="text-xs text-slate-400 mt-1">รูปลานและบริเวณรอบลานสำหรับทำการตลาด — LIFF แสดงต่อจากรูปปก เรียงตามลำดับด้านล่าง</p>
          </div>
          <div class="flex flex-col sm:flex-row gap-2 sm:items-center">
            <div class="flex flex-wrap gap-1 p-1 bg-slate-100 dark:bg-slate-800 rounded-xl">
              <button *ngFor="let cat of imageCategories" type="button" (click)="uploadCategory = cat.value"
                class="px-3 h-9 rounded-lg text-xs font-bold transition-all flex items-center gap-1 border-none cursor-pointer"
                [ngClass]="uploadCategory === cat.value
                  ? 'bg-white dark:bg-slate-900 text-amber-700 dark:text-amber-300 shadow-sm'
                  : 'bg-transparent text-slate-500 hover:text-amber-700'">
                <span class="material-icons text-[16px]">{{ cat.icon }}</span>
                {{ cat.label }}
              </button>
            </div>
            <label class="inline-flex items-center justify-center gap-2 px-4 h-11 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-sm cursor-pointer shadow-sm transition-all"
              [class.opacity-40]="draft().images.length >= maxGalleryImages"
              [class.pointer-events-none]="draft().images.length >= maxGalleryImages">
              <span class="material-icons text-[18px]">add_photo_alternate</span>
              เพิ่มรูป{{ categoryLabel(uploadCategory) }}
              <input type="file" accept="image/*" multiple class="hidden" (change)="onGallerySelected($event)" />
            </label>
          </div>
        </div>

        <div class="flex flex-wrap gap-2">
          <button type="button" (click)="setGalleryFilter('')"
            class="px-3 h-8 rounded-full text-xs font-bold border transition-all cursor-pointer"
            [ngClass]="galleryFilter === ''
              ? 'bg-amber-50 border-amber-300 text-amber-700 dark:bg-amber-900/30 dark:border-amber-700 dark:text-amber-300'
              : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300'">
            ทั้งหมด {{ galleryCount('') }}
          </button>
          <button *ngFor="let cat of imageCategories" type="button" (click)="setGalleryFilter(cat.value)"
            class="px-3 h-8 rounded-full text-xs font-bold border transition-all flex items-center gap-1 cursor-pointer"
            [ngClass]="galleryFilter === cat.value
              ? 'bg-amber-50 border-amber-300 text-amber-700 dark:bg-amber-900/30 dark:border-amber-700 dark:text-amber-300'
              : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300'">
            <span class="material-icons text-[14px]">{{ cat.icon }}</span>
            {{ cat.label }} {{ galleryCount(cat.value) }}
          </button>
        </div>

        <div *ngIf="filteredImages.length; else noGallery" class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          <div *ngFor="let img of filteredImages; let i = index; let first = first; let last = last; trackBy: trackByImage"
            class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 overflow-hidden flex flex-col"
            [class.opacity-60]="!img.isActive">
            <div class="relative aspect-[16/10] bg-slate-200 dark:bg-slate-800">
              <button type="button" (click)="openImageModal(imageSrc(img))" class="w-full h-full p-0 border-none cursor-zoom-in">
                <img [src]="imageSrc(img)" alt="" class="w-full h-full object-cover" />
              </button>
              <span class="absolute top-2 left-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-slate-900/70 text-white">
                #{{ i + 1 }}
              </span>
              <span *ngIf="img.pendingBase64" class="absolute top-2 right-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-400 text-slate-900">
                รออัปโหลด
              </span>
            </div>
            <div class="p-3 space-y-2 flex-1">
              <div class="flex flex-wrap gap-1">
                <button *ngFor="let cat of imageCategories" type="button" (click)="patchImage(img.uiKey, { category: cat.value })"
                  [title]="cat.label"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center border transition-all cursor-pointer"
                  [ngClass]="img.category === cat.value
                    ? 'bg-amber-400 border-amber-400 text-slate-900'
                    : 'bg-white dark:bg-slate-900 border-slate-100 dark:border-slate-700 text-slate-400 hover:text-amber-600'">
                  <span class="material-icons text-[16px]">{{ cat.icon }}</span>
                </button>
                <span class="ml-auto self-center text-[11px] font-bold text-slate-500">{{ categoryLabel(img.category) }}</span>
              </div>
              <input placeholder="คำบรรยาย (TH)"
                class="w-full h-[38px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="img.captionTh" (ngModelChange)="patchImage(img.uiKey, { captionTh: $event })" [ngModelOptions]="{ standalone: true }" />
              <input placeholder="Caption (EN)"
                class="w-full h-[38px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="img.captionEn" (ngModelChange)="patchImage(img.uiKey, { captionEn: $event })" [ngModelOptions]="{ standalone: true }" />
            </div>
            <div class="px-3 pb-3 flex items-center gap-1">
              <button type="button" (click)="moveImage(img.uiKey, -1)" [disabled]="first" title="เลื่อนขึ้น"
                class="w-8 h-8 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 disabled:opacity-30 transition-all">
                <span class="material-icons text-base">arrow_back</span>
              </button>
              <button type="button" (click)="moveImage(img.uiKey, 1)" [disabled]="last" title="เลื่อนลง"
                class="w-8 h-8 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 disabled:opacity-30 transition-all">
                <span class="material-icons text-base">arrow_forward</span>
              </button>
              <button type="button" (click)="patchImage(img.uiKey, { isActive: !img.isActive })"
                [title]="img.isActive ? 'ซ่อนจาก LIFF' : 'แสดงบน LIFF'"
                class="w-8 h-8 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 transition-all"
                [ngClass]="img.isActive ? 'text-emerald-500' : 'text-slate-400'">
                <span class="material-icons text-base">{{ img.isActive ? 'visibility' : 'visibility_off' }}</span>
              </button>
              <button type="button" (click)="removeImage(img.uiKey)" title="ลบรูป"
                class="ml-auto w-8 h-8 rounded-lg inline-flex items-center justify-center border border-rose-100 dark:border-rose-900/40 bg-rose-50 dark:bg-rose-900/20 text-rose-500 hover:bg-rose-100 transition-all">
                <span class="material-icons text-base">delete</span>
              </button>
            </div>
          </div>
        </div>
        <ng-template #noGallery>
          <div class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 py-12 text-center text-slate-400">
            <span class="material-icons text-3xl mb-2 opacity-40 block">photo_library</span>
            <p class="font-bold">{{ galleryFilter ? 'ยังไม่มีรูปหมวด ' + categoryLabel(galleryFilter) : 'ยังไม่มีรูปภาพ' }}</p>
            <p class="text-xs mt-1">เลือกหมวดแล้วกด “เพิ่มรูป” (เลือกได้หลายรูปพร้อมกัน ไม่เกิน 10MB ต่อรูป)</p>
          </div>
        </ng-template>
      </section>

      <!-- Amenities -->
      <section *ngIf="editTab() === 'amenity'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
        <div>
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">verified_user</span>
            สิ่งอำนวยความสะดวก / ความปลอดภัย
            <span class="text-xs font-bold text-slate-400">(เปิด {{ enabledAmenityCount }})</span>
          </h2>
          <p class="text-xs text-slate-400 mt-1">ไอคอนที่เปิดจะแสดงบนการ์ด Home, หน้ารายละเอียดลาน และแผนที่ — ใส่ข้อความเสริมสั้น ๆ ได้ เช่น “24 ชม.”</p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          <div *ngFor="let opt of amenityOptions"
            class="rounded-2xl border p-4 transition-all"
            [ngClass]="isAmenityOn(opt.code)
              ? 'border-amber-300 bg-amber-50/60 dark:border-amber-700 dark:bg-amber-900/20'
              : 'border-slate-100 bg-slate-50/60 dark:border-slate-700 dark:bg-slate-800/40'">
            <div class="flex items-center gap-3">
              <span class="w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0"
                [ngClass]="isAmenityOn(opt.code) ? 'bg-amber-400 text-slate-900' : 'bg-white dark:bg-slate-900 text-slate-400'">
                <span class="material-icons text-[20px]">{{ opt.icon }}</span>
              </span>
              <div class="min-w-0 flex-1">
                <p class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ opt.labelTh }}</p>
                <p class="text-[11px] text-slate-400 truncate">{{ opt.labelEn }}</p>
              </div>
              <ng-container *ngIf="opt.isSystem; else toggleTpl">
                <span class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-bold"
                  [ngClass]="draft().siteHasEv
                    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                    : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                  <span class="material-icons text-[12px]">lock</span>
                  {{ draft().siteHasEv ? 'มี (จากระบบ)' : 'ไม่มี (จากระบบ)' }}
                </span>
              </ng-container>
              <ng-template #toggleTpl>
                <button type="button" (click)="toggleAmenity(opt.code)" role="switch" [attr.aria-checked]="isAmenityOn(opt.code)"
                  class="relative w-11 h-6 rounded-full transition-colors border-none cursor-pointer shrink-0"
                  [ngClass]="isAmenityOn(opt.code) ? 'bg-amber-400' : 'bg-slate-200 dark:bg-slate-700'">
                  <span class="absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-all"
                    [ngClass]="isAmenityOn(opt.code) ? 'left-[22px]' : 'left-0.5'"></span>
                </button>
              </ng-template>
            </div>
            <div *ngIf="isAmenityOn(opt.code)" class="grid grid-cols-2 gap-2 mt-3">
              <input placeholder="ข้อความเสริม (TH)" maxlength="100"
                class="w-full h-[36px] px-3 rounded-lg border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="amenitySelection(opt.code)?.noteTh ?? ''"
                (ngModelChange)="patchAmenityNote(opt.code, 'noteTh', $event)" [ngModelOptions]="{ standalone: true }" />
              <input placeholder="Note (EN)" maxlength="100"
                class="w-full h-[36px] px-3 rounded-lg border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="amenitySelection(opt.code)?.noteEn ?? ''"
                (ngModelChange)="patchAmenityNote(opt.code, 'noteEn', $event)" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        </div>

        <p class="text-[11px] text-slate-400 flex items-center gap-1">
          <span class="material-icons text-[14px]">info</span>
          EV Charger อ้างอิงข้อมูลลานจากระบบ (parking_site) — ตอนเพิ่มลานจอดใหม่ รปภ./กล้อง/เจ้าหน้าที่/บัตรรายเดือน ถูกเปิดให้ตามข้อมูลลาน
        </p>
      </section>

      <!-- Blocks -->
      <section *ngIf="editTab() === 'content'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-4">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">view_agenda</span>
            บล็อกเนื้อหา
          </h2>
          <div class="flex flex-wrap gap-2">
            <button type="button" (click)="addBlock('text')"
              class="px-3 py-2 rounded-xl text-xs font-bold bg-amber-400 hover:bg-amber-500 text-slate-900 border-none shadow-sm transition-all flex items-center gap-1">
              <span class="material-icons text-[16px]">notes</span> ข้อความ
            </button>
            <button type="button" (click)="addBlock('image')"
              class="px-3 py-2 rounded-xl text-xs font-bold bg-slate-100 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 hover:border-amber-300 hover:text-amber-700 transition-all flex items-center gap-1">
              <span class="material-icons text-[16px]">image</span> รูป
            </button>
          </div>
        </div>

        <div *ngFor="let block of draft().blocks; let i = index; trackBy: trackByBlock"
          class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <div class="flex flex-wrap items-center gap-2">
              <span class="inline-flex w-8 h-8 items-center justify-center rounded-lg bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 text-xs font-black">{{ i + 1 }}</span>
              <select
                class="h-[40px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs font-bold outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="block.section"
                (ngModelChange)="patchBlock(i, { section: $event })"
                [ngModelOptions]="{ standalone: true }">
                <option *ngFor="let opt of sectionOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
              <select
                class="h-[40px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs font-bold outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="block.blockType"
                (ngModelChange)="patchBlock(i, { blockType: $event })"
                [ngModelOptions]="{ standalone: true }">
                <option *ngFor="let opt of blockTypeOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
            </div>
            <div class="flex gap-1">
              <button type="button" (click)="moveBlock(i, -1)" title="ขึ้น"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">arrow_upward</span>
              </button>
              <button type="button" (click)="moveBlock(i, 1)" title="ลง"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">arrow_downward</span>
              </button>
              <button type="button" (click)="removeBlock(i)" title="ลบ"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-rose-100 dark:border-rose-900/40 bg-rose-50 dark:bg-rose-900/20 text-rose-500 hover:bg-rose-100 transition-all">
                <span class="material-icons text-base">delete</span>
              </button>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">หัวข้อบล็อก (TH)</label>
              <input
                class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="block.titleTh" (ngModelChange)="patchBlock(i, { titleTh: $event })" [ngModelOptions]="{ standalone: true }" />
            </div>
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">หัวข้อบล็อก (EN)</label>
              <input
                class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="block.titleEn" (ngModelChange)="patchBlock(i, { titleEn: $event })" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>

          <ng-container [ngSwitch]="block.blockType">
            <div *ngSwitchCase="'text'" class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">เนื้อหา (TH)</label>
                <textarea rows="3" placeholder="ข้อความอธิบาย..."
                  class="w-full px-3 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                  [ngModel]="block.bodyTh" (ngModelChange)="patchBlock(i, { bodyTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
              </div>
              <div>
                <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">เนื้อหา (EN)</label>
                <textarea rows="3" placeholder="Description..."
                  class="w-full px-3 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                  [ngModel]="block.bodyEn" (ngModelChange)="patchBlock(i, { bodyEn: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
              </div>
            </div>

            <div *ngSwitchCase="'image'" class="space-y-3">
              <div class="flex flex-wrap gap-3 items-start">
                <button *ngIf="blockSrc(block)" type="button" (click)="openImageModal(blockSrc(block))"
                  class="w-40 h-28 rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 p-0 shadow-sm">
                  <img [src]="blockSrc(block)" alt="" class="w-full h-full object-cover" />
                </button>
                <div *ngIf="!blockSrc(block)"
                  class="w-40 h-28 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 flex items-center justify-center text-slate-300">
                  <span class="material-icons">image</span>
                </div>
                <div class="space-y-2">
                  <label class="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 border border-amber-100 dark:border-amber-800/50 font-bold text-xs cursor-pointer">
                    <span class="material-icons text-[16px]">upload</span>
                    เลือกรูป
                    <input type="file" accept="image/*" class="hidden" (change)="onBlockImageSelected(i, $event)" />
                  </label>
                  <button *ngIf="blockSrc(block)" type="button" (click)="clearBlockImage(i)"
                    class="block text-xs font-bold text-rose-500 hover:underline">ลบรูป</button>
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">คำบรรยายรูป (TH)</label>
                  <input placeholder="optional"
                    class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                    [ngModel]="block.bodyTh" (ngModelChange)="patchBlock(i, { bodyTh: $event })" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div>
                  <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">คำบรรยายรูป (EN)</label>
                  <input placeholder="optional"
                    class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                    [ngModel]="block.bodyEn" (ngModelChange)="patchBlock(i, { bodyEn: $event })" [ngModelOptions]="{ standalone: true }" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div *ngIf="!draft().blocks.length"
          class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 py-12 text-center text-slate-400">
          <span class="material-icons text-3xl mb-2 opacity-40 block">view_agenda</span>
          <p class="font-bold">ยังไม่มีบล็อก</p>
          <p class="text-xs mt-1">กดปุ่มด้านบนเพื่อเพิ่มข้อความ / รูป</p>
        </div>
      </section>
    </div>
  </ng-container>
</div>

<app-pss-loading *ngIf="isLoading() || isSaving()"></app-pss-loading>

<div *ngIf="showImageModal"
  class="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4"
  (click)="closeImageModal()">
  <button type="button" class="absolute top-4 right-4 text-white hover:text-amber-400 transition-colors z-[10000]"
    (click)="closeImageModal()">
    <span class="material-icons text-4xl">close</span>
  </button>
  <div class="relative max-w-[90vw] max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl border border-white/10"
    (click)="$event.stopPropagation()">
    <img [src]="selectedImageUrl" alt="" class="object-contain max-w-full max-h-[90vh]">
  </div>
</div>

<app-pss-confirm-modal
  *ngIf="isDeleteConfirmOpen()"
  title="ยืนยันการลบลานจอดออกจากหน้า Home?"
  message="ต้องการลบลานจอด"
  [highlight]="deleteTarget()?.titleTh || deleteTarget()?.siteName || ''"
  messageSuffix="ออกจากหน้า Home หรือไม่"
  confirmLabel="ลบลานจอด"
  icon="delete_forever"
  variant="danger"
  [loading]="isSaving()"
  (confirm)="confirmDelete()"
  (cancel)="closeDeleteConfirm()">
</app-pss-confirm-modal>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.SitePublicProfile"
  [entityId]="draft().id"
  [subtitle]="draft().titleTh || draft().siteName"
  (close)="showActivityHistory = false">
</app-modal-admin-activity-history>
